import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-infinite-scroll-sensor", () => {
    it("should match to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-infinite-scroll-sensor
                name="some-name"
                id="infinite1"
            ></ux-infinite-scroll-sensor>`
        );
        const el = await page.find("ux-infinite-scroll-sensor");
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-infinite-scroll-sensor
                name="some-name"
                id="infinite1"
            ></ux-infinite-scroll-sensor>`
        );
    });
});
